"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const main_service_1 = require("../../../main/main.service");
const material_1 = require("@angular/material");
const BaseComponent_1 = require("../../BaseComponent");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const map_service_1 = require("../../map.service");
const acl_service_1 = require("../../acl/acl.service");
const app_service_1 = require("../../app.service");
const file_data_service_1 = require("@src/app/v2/commons/file-data.service");
const stream_data_service_1 = require("@src/app/v2/commons/stream-data.service");
const core_2 = require("@ngx-translate/core");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
const operators_1 = require("rxjs/operators");
const Constants_1 = require("../../Constants");
const map_data_service_1 = require("@src/app/v2/commons/map-data.service");
const upload_wms_component_1 = require("../upload-wms/upload-wms.component");
class UploadGlobalComponent extends BaseComponent_1.BaseComponent {
    constructor(dialogRef, mainService, route, router, fourD, snackBar, dialog, mapService, permissions, service, v2FileService, v2MapService, vsStreams, t, uiManager) {
        super(router, snackBar, dialog);
        this.dialogRef = dialogRef;
        this.mainService = mainService;
        this.route = route;
        this.router = router;
        this.fourD = fourD;
        this.mapService = mapService;
        this.permissions = permissions;
        this.service = service;
        this.v2FileService = v2FileService;
        this.v2MapService = v2MapService;
        this.vsStreams = vsStreams;
        this.t = t;
        this.uiManager = uiManager;
        this.showAddDataFeed = false;
        this.showAddDataWMS = false;
        this.fakeFile = null;
        this.debug = Constants_1.Constants.debug_off;
        // state
        this.isLoading = true;
        // all items in our library
        this.items = [];
        // selected repo/category/item
        this.selectedItem = null;
        // menu structure
        this.structure = [
            { id: 'wms', show: true, label: 'MAP.LIBRARY.WMS', icon: 'external-link-alt', open: false, opening: false, loading: false, showCount: true, tools: [
                    { tooltip: 'MAP.LIBRARY.IMPORT_URL', icon: 'link', action: 'importFromURL' }
                ], items: [] },
            { id: 'nm', show: true, label: 'MAP.LIBRARY.NATIONAL_MAP', icon: 'history', open: false, items: [
                    { id: 'nm1', label: 'MAP.LIBRARY.NATIONAL_MAP_1', icon: 'map', open: false, items: [
                            { id: 'nm5', label: 'MAP.LIBRARY.NATIONAL_MAP_5', icon: 'globe', open: false, selectable: true },
                            { id: 'nm6', label: 'MAP.LIBRARY.NATIONAL_MAP_6', icon: 'globe', open: false, selectable: true },
                            { id: 'nm7', label: 'MAP.LIBRARY.NATIONAL_MAP_7', icon: 'globe', open: false, selectable: true },
                            { id: 'nm8', label: 'MAP.LIBRARY.NATIONAL_MAP_8', icon: 'globe', open: false, selectable: true },
                            { id: 'nm9', label: 'MAP.LIBRARY.NATIONAL_MAP_9', icon: 'globe', open: false, selectable: true }
                        ] },
                    { id: 'nm2', label: 'MAP.LIBRARY.NATIONAL_MAP_2', icon: 'map', open: false, items: [] },
                    { id: 'nm3', label: 'MAP.LIBRARY.NATIONAL_MAP_3', icon: 'map', open: false, items: [] },
                    { id: 'nm4', label: 'MAP.LIBRARY.NATIONAL_MAP_4', icon: 'map', open: false, items: [] },
                ] },
            { id: 'gsa', show: true, label: 'MAP.LIBRARY.GEOSCIENCE', icon: 'history', open: false, items: [] },
            { id: 'favourites', show: this.permissions.check('library', 'see_favourites'), label: 'MAP.LIBRARY.FAVOURITES', icon: 'star', open: true, items: [
                    { id: 'layers', label: 'MAP.LIBRARY.IMAGE_LAYERS', icon: 'globe-americas', open: false, items: [] },
                    { id: 'terrains', label: 'MAP.LIBRARY.TERRAIN_MODELS', icon: 'mountain', open: false, items: [] },
                    { id: 'models', label: 'MAP.LIBRARY.MODELS', icon: 'cubes', open: false, items: [] },
                ] },
            { id: 'latest', show: this.permissions.check('library', 'see_latest_changes'), label: 'MAP.LIBRARY.LATEST', icon: 'history', open: false, items: [] }
        ];
        this.sharedTransforms = [];
        this.datasets = [];
        // sorted into categories
        this.categories = null;
    }
    ngOnInit() {
        // crete our categories, with sub-jobs/transforms underneath
        this.categories = new Map();
        this.recategorizeAllItems();
        this.getSharedTransforms();
        this.addSubscription('sceneFolderAdd', this.v2MapService.scene.events.pipe(operators_1.filter(s => s.event == 'ADD'), operators_1.flatMap(s => s.item.sceneFolder)).subscribe(folder => {
            this.sceneFolder = folder;
            this.refreshItems();
        }));
    }
    dragOver(e) {
        e.preventDefault();
        this.mainService.isOver = true;
        return false;
    }
    helloDrop(e, entering) {
        this.mainService.isOver = entering;
    }
    toggleShowDataFeed() {
        if (!this.fakeFile) {
            this.fakeFile = { name: '', url: '', username: '', password: '' };
        }
        this.showAddDataFeed = !this.showAddDataFeed;
    }
    toggleShowDataWMS() {
        this.showAddDataWMS = !this.showAddDataWMS;
    }
    select(item) {
        if (item && item.id) {
            this.selectedItem = item;
        }
    }
    unselect() {
        this.selectedItem = null;
    }
    uploadFakeFile() {
        let $fake = {
            preventDefault: function () { },
            dataTransfer: null
        };
        // const handleInput = function(e) {
        //   console.log('change occurred', e);
        // }
        // const fileInputElement = document.getElementById('fileInput1') as HTMLInputElement;
        // fileInputElement.addEventListener('change', handleInput, false);
        const json = JSON.stringify(this.fakeFile, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        let file = new File([blob], this.fakeFile.name + '.redirect', { type: 'application/json', lastModified: new Date().getTime() });
        let container = new DataTransfer();
        container.items.add(file);
        $fake.dataTransfer = container;
        // const theseFiles = container.files;
        // fileInputElement.files = theseFiles;
        // fileInputElement.value = null;
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = 'sample-profile.kmz';                     //filename to download
        // a.click();
        console.log('### fakeFile()', json, blob, file, $fake);
        this.mainService.dropFile($fake);
        this.dialogRef.close();
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    getSharedTransforms() {
        let wms = this.fourD.transformTypes.find(t => t.uid == 'WMS');
        let wmsCheck = this.fourD.transformTypes.find(t => t.uid == 'wms_check');
        if (wms && wmsCheck) {
            let types = this.fourD.transformTypes.find(t => t.uid == 'WMS').id + '|' + this.fourD.transformTypes.find(t => t.uid == 'wms_check').id;
            const q = this.fourD.V.searchByObject(_4d_mapper_1.Transform).equals('account', this.fourD.activeTeam).equals('transformType', types).queryObservable().subscribe(res => {
                if (res.items.length) {
                    this.sharedTransforms = res.items;
                    let wms = this.findNode();
                    let find = this.findNode('shared', wms.items);
                    if (find) {
                        find.items = this.sharedTransforms;
                    }
                }
                this.loading = false;
            }, e => {
                this.loading = false;
            });
        }
        else {
            this.loading = false;
        }
    }
    refreshItems() {
        let me = this;
        let wms = this.findNode('wms');
        wms.loading = true;
        this.fourD.V.searchByObject(_4d_mapper_1.Dataset).complexQuery({
            op: 'and',
            items: [
                {
                    col: 'folder',
                    op: '=',
                    val: this.sceneFolder.id
                },
                {
                    col: 'dataType',
                    op: 'is',
                    where: {
                        col: 'uid',
                        op: 'in',
                        val: ['wfs', 'arcgis', 'wms']
                    }
                }
            ]
        }).queryObservable().subscribe(foundDatasets => {
            me.datasets = foundDatasets.items;
            var node = me.findNode('wms');
            wms.loading = false;
            node.items = foundDatasets.items.map(dataset => {
                let uid = me.uuidv4();
                return { id: uid, label: dataset.name, icon: 'cloud-download-alt', open: false, loading: false, metaopen: false, showCount: true, dataset: dataset, tools: [
                        { tooltip: 'MAP.LIBRARY.REMOVE_LIST', icon: 'times', action: () => { dataset.destroyObservable().subscribe(_ => { node.items = []; me.refreshItems(); }); } },
                        { tooltip: 'MAP.LIBRARY.MORE_INFO', icon: 'info', action: () => { me.toggleMeta(uid); } }
                    ], items: dataset['layers'].map((layer, i) => {
                        let lid = me.uuidv4();
                        var tools = [];
                        // if ( dataset.dataType._adhocTransforms.length && dataset.dataType._adhocTransforms[0] ) {
                        var tt = dataset.dataType._adhocTransforms[0];
                        layer.loading = false;
                        tools.push({ tooltip: 'MAP.LIBRARY.IMPORT', icon: 'cloud-download-alt', action: () => {
                                dataset.applyTransform(tt, { layer: layer }).subscribe(s => me.openSnackBarInfo('EXTERNAL.STARTED_PROCESSING'), e => me.openSnackBarError('EXTERNAL.PROCESSING_ERROR'));
                            } });
                        if (layer && layer.desc) {
                            tools.push({ tooltip: 'MAP.LIBRARY.MORE_INFO', icon: 'info', action: () => { me.toggleMeta(lid); } });
                        }
                        // }
                        return { id: lid, label: layer.name, tools: tools, layer: layer };
                    }) };
            });
            node.items.push({ id: 'shared', label: 'MAP.LIBRARY.SHARED', icon: 'share-alt', open: false, showCount: true, items: this.sharedTransforms });
        });
    }
    toggleItem(item) {
        item.open = !item.open;
        item.opening = true;
        this.unselect();
        // slow to open, fast to close
        if (item.open) {
            setTimeout(() => { item.opening = false; }, 1200);
        }
        else {
            setTimeout(() => { item.opening = false; }, 500);
        }
    }
    toggleMeta(uid = null) {
        let wms = this.findNode();
        let find = this.findNode(uid, wms.items);
        if (find) {
            find.metaopen = !find.metaopen;
        }
        else {
            wms.items.forEach(item => {
                let f = this.findNode(uid, item.items);
                if (f) {
                    f.metaopen = !f.metaopen;
                }
            });
        }
    }
    findNode(id = 'wms', inStructure = null) {
        if (!inStructure) {
            inStructure = this.structure;
        }
        return inStructure.find(base => base.id == id);
    }
    recategorizeAllItems() {
        this.items.map(item => {
            if (item.category) {
                if (!this.categories.has(item.category)) {
                    this.categories.set(item.category, {});
                }
                let category = this.categories.get(item.category);
                category[item.id] = item;
                this.categories.set(item.category, category);
            }
        });
        this.isLoading = false;
    }
    clicker(tool) {
        if (tool && tool.action) {
            if (typeof tool.action == 'string') {
                if (this[tool.action])
                    this[tool.action](tool);
            }
            else
                tool.action();
        }
    }
    // clickedMap(movement, rightClick: boolean, checkedPosition): ClickDisplay {
    //   return ClickDisplay.None;
    // }
    /* ADD SPECIFIC ACTION HERE */
    importFromURL() {
        let wms = this.findNode('wms');
        var inp = {};
        this.openDialog('EXTERNAL.PROMPT_TITLE', 'EXTERNAL.PROMPT_BODY', 'GENERIC.OK', 'GENERIC.CANCEL', inp).subscribe(url => {
            if (url) {
                var ds = new _4d_mapper_1.Dataset(this.fourD.V);
                ds.name = "link.url";
                ds.folder = this.sceneFolder;
                ds.account = this.fourD.activeTeam;
                wms.loading = true;
                ds.saveObservable().subscribe(s => {
                    // pushed here so it shows uploading indicator
                    wms.items.push({ label: url, tools: [], loading: true });
                    // this is the event catcher
                    this.vsStreams.fileEvents.pipe(operators_1.filter(e => e.item.id == ds.id && !!e.item.dataType), operators_1.take(1)).subscribe(s => {
                        this.refreshItems();
                    });
                    this.openSnackBarInfo('EXTERNAL.STARTED_UPLOAD');
                    ds.uploadString(url, "link.url").subscribe(ss => console.log(ss), e => console.log(e));
                });
            }
        });
        /*
        this.structure.forEach ( base => {
          if ( base.id == 'wms' ) {
            if ( !base.open ) {
              base.open = true;
            }
            base.items.push ({ label:'Layers from BingoYalla', icon:'cloud-download-alt', open:true, items:[
              { label:'Some layer', tools:[{ tooltip:'Import', icon:'link', action:'importThisFromURL' }] },
              { label: 'another layer', tools:[{ tooltip:'Import', icon:'link', action:'importThisFromURL' }] },
              { label: 'yet another layer', tools:[{ tooltip:'Import', icon:'link', action:'importThisFromURL' }] }
            ] });
          }
        });
    
        console.log ( 'importFromURL()');
        */
    }
    importFromWMS() {
        let dialogRef = this.dialog.open(upload_wms_component_1.UploadWMSComponent, {
            panelClass: 'custom-dialog-container'
        });
        dialogRef.afterClosed().subscribe();
    }
}
exports.UploadGlobalComponent = UploadGlobalComponent;
